import script from "./CopyTextButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./CopyTextButton.vue?vue&type=script&lang=ts&setup=true"

import "./CopyTextButton.vue?vue&type=style&index=0&id=310e41f0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-310e41f0"]])

export default __exports__